import React from 'react'
import style from './startsoon.module.css'

function Biologybypurlove() {
  return (
    <div className = {style.start_soon}>
        <img src='https://edge.uacdn.net/static/thumbnail/course/D597D6B6-B53E-43B6-8189-58CACDDB782F_plus.png?q=100&w=512' alt='_Sumit_img'/>
        <div>
          <p>HINDI    UPSC NDA</p>
          <h4>Super 30 : Practice Course on Biology for NDA I - 2022</h4> 
          <p>Starts on 11 Mar 2022 25 lessons</p> 
          <p>Prulove Nda</p>  
        </div>
    </div>        
  )
}
export default Biologybypurlove;